<div class="page-wrapper">
  <div class="welcome-card">

    <!-- Icon -->
    <div class="icon-wrapper">
      <div class="check-circle">
        ✓
      </div>
    </div>

    <!-- Heading -->
    <h2 class="title">Welcome to Event Platform</h2>
    <p class="subtitle">
      Your profile has been verified. Let's complete your onboarding.
    </p>

    <!-- Account Info -->
    <div class="info-section">
      <h4 class="section-title">Account Information</h4>

      <div class="info-box">
        <div class="info-header">
          <span class="org-icon">🏢</span>
          <span class="org-type">Organisation Account</span>
        </div>

        <div class="info-row">
          <span class="label">Brand / Display Name</span>
          <!-- <span class="value">{{this.organizer.first_name}}</span> -->
        </div>

        <div class="info-row">
          <span class="label">Legal Name</span>
          <!-- <span class="value">{{this.organizer.company_name}}</span> -->
        </div>
      </div>
    </div>

    <!-- Button -->
    <button class="primary-btn" (click)="goToCompanyDetails()">
      Continue to Company Details
    </button>

  </div>
</div>
<div class="logout">
  <button (click)="logout()" class="primary-btn">Logout</button>
</div>